/**
 * BookSelectorDropdown — single-book override picker for SGP calculations.
 * Extracted verbatim from SgpFlowScreen.jsx (god-file decomposition).
 * Renders only when `visible` is true (parent guards with &&).
 */

import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { styles } from '../screens/sgpFlowStyles';

const BOOK_OPTIONS = [
  { key: null, name: 'All Books (Default)' },
  { key: 'FanDuel', name: 'FanDuel Only' },
  { key: 'DraftKings', name: 'DraftKings Only' },
  { key: 'Caesars', name: 'Caesars Only' },
  { key: 'BetMGM', name: 'BetMGM Only' },
  { key: 'PointsBet', name: 'PointsBet Only' },
  { key: 'BetRivers', name: 'BetRivers Only' },
  { key: 'WynnBet', name: 'WynnBet Only' },
  { key: 'Barstool', name: 'Barstool Only' },
  { key: 'FOX Bet', name: 'FOX Bet Only' },
  { key: 'Unibet', name: 'Unibet Only' },
  { key: 'bet365', name: 'bet365 Only' },
  { key: 'Pinnacle', name: 'Pinnacle Only' },
  { key: 'Circa Sports', name: 'Circa Sports Only' },
  { key: 'SI Sportsbook', name: 'SI Sportsbook Only' },
];

export default function BookSelectorDropdown({ bookOverride, onSelect, onClose }) {
  return (
    <View style={styles.bookSelectorDropdown}>
      <Text style={styles.bookSelectorTitle}>Select Books for Calculation:</Text>
      <View style={styles.bookList}>
        {BOOK_OPTIONS.map((book) => (
          <Pressable
            key={book.key || 'all'}
            onPress={() => {
              onSelect(book.key);
              onClose();
            }}
          >
            {({ hovered }) => (
              <View style={[styles.bookOption, bookOverride === book.key ? styles.bookOptionActive : null, hovered && bookOverride !== book.key && styles.bookOptionHovered]}>
                <Text style={[styles.bookOptionText, bookOverride === book.key ? styles.bookOptionTextActive : null]}>
                  {book.name}
                </Text>
              </View>
            )}
          </Pressable>
        ))}
      </View>
    </View>
  );
}
